import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { SimProfilesDetailsTabsLayout } from './SimProfilesDetailsTabsLayout';
import { DetailPageTitle } from 'src/common/components/AppLayout/DetailsPage/DetailsPageTitle';
import { Routes } from 'src/Routes.constants';
import { useParams } from 'react-router';

type SimDetailsRoutingParams = {
  iccid?: string;
};

const SimProfilesDetailsPageTitle = () => {
  const { t } = useTranslation();
  const { iccid } = useParams<SimDetailsRoutingParams>();

  return (
    <DetailPageTitle
      title={`${t('simInventory.sim')} ${iccid}`}
      rootLocation={{
        to: Routes.simInventory,
        name: t('simProfiles.simProfiles'),
      }}
      currentLocationName={t('simInventory.SIMDetails')}
    />
  );
};

export const SimProfilesDetailsPageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageLayout title={<SimProfilesDetailsPageTitle />}>
      <SimProfilesDetailsTabsLayout>{children}</SimProfilesDetailsTabsLayout>
    </PageLayout>
  );
};
